import React, { useEffect, useState } from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { SectionHeading } from "components/misc/Headings";
import { FaEye, FaDownload } from "react-icons/fa"; // Import icons from react-icons

const API_URL = process.env.REACT_APP_IS_PROD == "true" ? process.env.REACT_APP_API_URL_PROD : process.env.REACT_APP_API_URL_DEV;

const Card = styled.div`
  ${tw`bg-white shadow-lg rounded-2xl p-4 sm:p-6 w-full max-w-4xl mx-auto`}
`;

const HeadingRow = styled.div`
  ${tw`flex justify-between mb-6`}
`;

const Heading = styled(SectionHeading)`
  ${tw`hover:text-[#0049AC] text-xl sm:text-2xl lg:text-3xl mt-4 mb-0`}
`;

const Table = styled.div`
  ${tw`w-full`}
`;

const TableRow = styled.div`
  ${tw`flex flex-col sm:flex-row w-full justify-between items-start sm:items-center py-3 border-b last:border-b-0 gap-4 sm:gap-0`}
`;

const TableData = styled.div`
  ${tw`flex-1 text-sm sm:text-base md:text-lg font-semibold overflow-hidden whitespace-normal break-words pr-2`}
`;

const ButtonGroup = styled.div`
  ${tw`flex space-x-3`}
`;

const IconButton = styled.button`
  ${tw`p-2 rounded-full text-[#0049AC] hover:bg-[#0049AC] hover:text-white transition duration-300 focus:outline-none`}
`;

const ChecklistCard = () => {
  const [checklist, setChecklist] = useState([]);

  useEffect(() => {
    const fetchChecklist = async () => {
      try {
        const response = await fetch(`${API_URL}/web/home/all-checklist`, {
          headers: {
            'X-API-Key': process.env.REACT_APP_ACCESS_API_KEY
          }
        });
        const result = await response.json();

        if (result.header.resCode === 200 && result.data.length > 0) {
          // Sort the checklist data alphabetically by title
          const sortedChecklist = [...result.data[0]].sort((a, b) => a.title.localeCompare(b.title));
          setChecklist(sortedChecklist);
        }
      } catch (error) {
        console.error("Error fetching checklist data:", error);
      }
    };

    fetchChecklist();
  }, []);

  const handleView = (url) => {
    // Open PDF in new tab
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handleDownload = (url, title) => {
    // Create a temporary link element to trigger download
    const link = document.createElement('a');
    link.href = url;
    link.download = `${title}-checklist.pdf`; // Suggest a filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Card>
      <HeadingRow>
        <Heading>Discover World, Explore More About Your Visa</Heading>
      </HeadingRow>
      <Table>
        {checklist.map((item, index) => (
          <TableRow key={item.title}>
            <TableData>
              {index + 1}. {item.title} - {item.continent}
            </TableData>
            <ButtonGroup>
              <IconButton 
                onClick={() => handleView(item.visa_checklist)}
                title="View PDF"
              >
                <FaEye size={20} />
              </IconButton>
              <IconButton 
                onClick={() => handleDownload(item.visa_checklist, item.title)}
                title="Download PDF"
              >
                <FaDownload size={20} />
              </IconButton>
            </ButtonGroup>
          </TableRow>
        ))}
      </Table>
    </Card>
  );
};

export default ChecklistCard;